import { render, staticRenderFns } from "./add_virtual_dept_dialog.vue?vue&type=template&id=11f36c35&"
import script from "./add_virtual_dept_dialog.vue?vue&type=script&lang=js&"
export * from "./add_virtual_dept_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports